import { z } from 'zod';
import { templateAdvanceLogicV1Schema } from './advance-logic';
import { templateNamedWidgetSchema } from './base';
import { fieldLayoutShape } from './field-layout';
import { templateOptionsV1Schema } from './options';
import { templateParameterV1Schema } from './parameter';
import { templateReferenceV1Schema } from './reference';
import { TEXT_COLOR_VALUES, templateTextColorSchema } from './typography';

export const templateSelectSchema = templateNamedWidgetSchema.extend({
  type: z.literal('select'),
  options: templateOptionsV1Schema,
  isRequired: z.boolean(),
  labelColor: templateTextColorSchema.default(TEXT_COLOR_VALUES.BLACK),
  isSearchable: z.boolean(),
  parameter: templateParameterV1Schema.optional(),
  placeholder: z.string(),
  value: z.string(),
  ...fieldLayoutShape,
  advanceLogics: templateAdvanceLogicV1Schema,
  reference: templateReferenceV1Schema,
});

export type TemplateSelectV1 = z.infer<typeof templateSelectSchema>;
